import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';


const loggedOutArticles = [
  {
    id: 1,
    title: "The Journey of Alfa Entrepreneurs: Visionaries, Innovators, and Changemakers",
    excerpt: "Humans have been doing business for thousands of years, and the world of entrepreneurship has been evolving for generations...",
    image: "/ArticleOne.jpeg",
    date: "February 1, 2025"
  },
  {
    id: 2,
    title: "Why should you Join ‘Alfa Entrepreneur’?",
    excerpt: "If you’re fed up with living in the shadows and want to get acknowledged by society in the form of a visionary, a leader, and a changemaker, the Alfa Entrepreneur community is the right place for you...",
    image: "/ArticleTwo.jpeg",
    date: "February 2, 2025"
  },
  {
    id: 3,
    title: "5 Leadership Skills Every Young Entrepreneur must Develop",
    excerpt: "Starting your career as a young entrepreneur might be thrilling, but it comes with never-ending challenges. Your journey might be fuelled by your passion and creativity, but mastering some critical leadership skills...",
    image: "/ArticleThird.jpg",
    date: "February 3, 2025"
  },
  {
    id: 4,
    title: "Networking with Alfa Entrepreneurs: Transform Your Business",
    excerpt: "An entrepreneurial experience is something that everyone wants to have at least once in their life. However, being an entrepreneur is not steady and easy. Entrepreneurship comes with its own set of challenges. However...",
    image: "/ArticleFourth.png",
    date: "February 4, 2025"
  },
  {
    id: 5,
    title: "Mentorship Matters: Learning from Fellow Entrepreneurs",
    excerpt: "At Alfa Entrepreneurs, we believe that walking together is the key to success in the entrepreneurial journey. Keeping this in mind, this platform was designed to foster healthy relationships build connections...",
    image: "/ArticleFive.png",
    date: "February 5, 2025"
  },
  {
    id: 6,
    title: "How to Find Opportunities in a Competitive Market",
    excerpt: "In today's environment, managing a business is like navigating turbulent waters; it's unknown, unpredictable, and extremely competitive. Customers have an abundance of options, the market is congested, and trends...",
    image: "/ArticleSeven7.jpg",
    date: "February 6, 2025"
  },
  // Add more articles with similar structure
];

interface Article {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  date: string;
}

const loggedInArticles: Article[] = [
  {
    id: 1,
    title: "The Secrets of Debt-Free Scaling: How to Grow Without Borrowing Money",
    excerpt: "The idea of scaling a business might seem difficult without outside help or debt borrowing, but it is completely achievable if you use the right strategies. Many entrepreneurs believe that the only way to expand their...",
    image: "/ArticleSix.jpg",
    date: "February 6, 2025"
  },
  {
    id: 2,
    title: "The Dark Side of Entrepreneurship: Dealing with Loneliness, Fear, and Anxiety",
    excerpt: "Becoming an entrepreneur is often symbolised as a glorified path of passion, dedication, hard work and continuous hustle for success. However, this journey can become a lonely path filled with fear and anxiety that...",
    image: "/ArticleSeven.png",
    date: "February 7, 2025"
  },
  {
    id: 3,
    title: "The Secret to Viral Growth: How to Engineer Word-of-Mouth Marketing ",
    excerpt: "In today's world, everyone, be it an individual or a business, wants to go viral and be seen by the right audience. But true word-of-mouth marketing (WOMM) isn’t just luck; there’s a whole science behind it. And...",
    image: "/ArticleEight.jpg",
    date: "February 8, 2025"
  },
  {
    id: 4,
    title: "Why Cash Flow is More Important Than Revenue and How to Master It?",
    excerpt: "Revenue is considered the most important parameter for defining a business’s success. But here’s something no one will tell you: you alone can’t get dependent on revenue for sustaining your business...",
    image: "/ArticleNine.jpg",
    date: "February 9, 2025"
  },
];

export default function ArticlesPage() {

  // Use this code while purchased mode is on

   const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
      useEffect(() => {
            setToken(localStorage.getItem('token')); // Reactively update token state
        if(!token){
            // window.location.href = "/";    when token is not present, redirect to Home page
        }
       }, [token]);

  const articles = token ? loggedInArticles : loggedOutArticles;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Latest Articles</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((article) => (
          <article key={article.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img
              src={article.image}
              alt={article.title}
              className="h-48 w-full object-cover"
            />
            <div className="p-6">
              <p className="text-sm text-gray-500">{article.date}</p>
              <h2 className="mt-2 text-xl font-semibold text-gray-900">{article.title}</h2>
              <p className="mt-2 text-gray-600">{article.excerpt}</p>
              <Link to = {`/articles/${article.id}`} >
              <button className="mt-4 text-indigo-600 hover:text-indigo-800">
                Read more →
              </button>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}